import { Button, type ButtonProps } from "../ui";
import { AsyncActionFrame } from "./AsyncActionFrame";
import { useDialogActionBusy } from "../ui/dialogActionScope";

export type AsyncActionButtonProps = Omit<ButtonProps, "loading"> & {
  /** Marks an action as running. The button is disabled and pulses without showing a spinner. */
  loading?: ButtonProps["loading"];
  /** Highlights an available action with the same pulse while keeping it interactive. */
  attention?: boolean;
  /** Tatsächliche Verarbeitung, falls `loading` zusätzlich den Submit-Riegel enthält. */
  backgroundPending?: boolean;
};

export function AsyncActionButton({
  attention = false,
  className,
  disabled = false,
  loading = false,
  backgroundPending,
  ...buttonProps
}: AsyncActionButtonProps) {
  useDialogActionBusy(backgroundPending ?? Boolean(loading));
  const isLoading = Boolean(loading);

  return (
    <AsyncActionFrame
      component={Button}
      {...buttonProps}
      active={isLoading}
      attention={attention}
      className={className}
      disabled={disabled || isLoading}
    />
  );
}
